import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { ReactComponent as ProfileIcon } from 'assets/images/svg/user-profile-icon.svg';

import container from 'containers/MyProfile';

import siteStyle from 'utils/siteStyle';

const GuestDisclaimer = ({ className, isLoggedIn, goToSignIn }) => {
  const { restoreSessionFinished } = useSelector((state) => state.session);

  if (!restoreSessionFinished) return null;

  if (isLoggedIn) return null;

  return (
    <section className={className}>
      <div
        className="w-full max-w-300 border border-light-grey-four rounded-2 px-4 py-6 md:flex md:gap-6 md:items-center md:px-6 md:py-9"
        onClick={goToSignIn}
        aria-hidden
      >
        <ProfileIcon className="w-10 h-10 fill-current text-dark" />
        <div className="mt-4 md:mt-0">
          <h2 className={siteStyle({
            common: 'text-5 leading-6 -tracking-0.2 text-dark font-bold',
            // bt: 'font-korolav uppercase',
            foh: 'font-rajdhani',
            default: 'font-primary',
          })}
          >
            You’re viewing as a guest
          </h2>
          <p className={siteStyle({ common: 'text-4 leading-5 -tracking-0.2 text-grey-3 mt-2', default: 'font-primary-two', foh: 'font-rajdhani' })}>
            Sign in or sign up to compare and book the best rates available.
          </p>
        </div>
        <button
          className="w-full h-12 flex justify-center items-center gap-1 border border-light-grey-four rounded-2 mt-6 focus:outline-none md:ml-auto md:w-fit md:mt-0 md:px-4"
          onClick={(e) => {
            e.stopPropagation();
            goToSignIn();
          }}
        >
          <ProfileIcon className="w-5 h-5 fill-current text-dark" />
          <p className={siteStyle({
            common: 'text-4 leading-5 -tracking-0.2 text-dark',
            // bt: 'font-korolav font-medium',
            foh: 'font-roboto',
            default: 'font-primary-two',
          })}
          >
            Sign in
          </p>
        </button>
      </div>
    </section>
  );
};

GuestDisclaimer.defaultProps = {
  className: '',
};

GuestDisclaimer.propTypes = {
  className: PropTypes.string,
  isLoggedIn: PropTypes.bool.isRequired,
  goToSignIn: PropTypes.func.isRequired,
};

export default container(GuestDisclaimer);
